module.exports = __webpack_public_path__ + "img/horizontal_7_5_pp2_8023.bfd12fda.png";